import { getStorageValue } from '../../shared/utils/storage';

export const SOURCE_STORAGE_KEY = 'source';
export const SOURCE_QUERY_KEY = 'source';
export const SOURCE_PLATFORM_KEY = 'platform';

export const NATIVE_APP_SOURCE = 'nativeapp';
export const NATIVE_IOS_SOURCE = 'ios';
export const NATIVE_ANDROID_SOURCE = 'android';

const initialSearchParams = new URLSearchParams(window.location.search).get('source');
const initialPlatformParams = new URLSearchParams(window.location.search).get('platform');

/**
 * Returns true if we are in an app.
 * @returns
 */
export function isInApp() {
    if (initialSearchParams === NATIVE_APP_SOURCE) {
        return true;
    }

    return getStorageValue(SOURCE_STORAGE_KEY) === NATIVE_APP_SOURCE;
}

/**
 * Returns  iOS or Android.
 */
export function getPlatform(): 'ios' | 'android' | undefined {
    const storedPlatform = getStorageValue<string>(SOURCE_PLATFORM_KEY);

    if (initialPlatformParams === NATIVE_IOS_SOURCE || storedPlatform === NATIVE_IOS_SOURCE) {
        return 'ios';
    }

    if (
        initialPlatformParams === NATIVE_ANDROID_SOURCE ||
        storedPlatform === NATIVE_ANDROID_SOURCE
    ) {
        return 'android';
    }

    return undefined;
}
